import React from "react";
import styled from "styled-components";
import { updateNFeConfig, getNFeConfig } from "../../../../api/nfe";
import LoadingInput from "../../../../_components/LoadingInput";
import Text from "../../../../_components/Text";
import Button from "../../../../_components/Button";
import IconButton from "../../../../_components/IconButton";
import Modal from "../../../../_components/Modal";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
`;

export default () => {
  const [showModal, ShowModal] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [config, setConfig] = React.useState({});

  async function loadNFeConfig() {
    setLoading(true);
    await getNFeConfig()
      .then((config) => {
        setConfig(config);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  }
  function saveNFeConfigToStorage(config) {
    let branch = window.localStorage.getItem("easygestorweb_current_branch");

    if (branch) {
      branch = JSON.parse(branch);
      branch["fiscal_config"] = config;
      window.localStorage.setItem(
        "easygestorweb_current_branch",
        JSON.stringify(branch)
      );
      setLoading(false);
      ShowModal(false);
    }
    toggleDisplayAlert();
  }
  function updateError() {
    setLoading(false);
    ShowModal(false);
    alert("Error");
  }
  function enterPressed(e) {
    if (e.key === "Enter") {
      update();
    }
  }
  async function update() {
    if (!config.nfe_serie || !config.nfe_number) {
      loadNFeConfig();
      ShowModal(false);
      return;
    }
    setLoading(true);
    await updateNFeConfig(config)
      .then((config) => saveNFeConfigToStorage(config))
      .catch(updateError);
  }
  function onChange(e) {
    let { name: key, value } = e.target;
    if (parseInt(value) < 1) {
      value = 1;
    }
    let newConfig = { ...config };
    newConfig[key] = value;
    setConfig(newConfig);
  }

  function openModal() {
    ShowModal(true);
    loadNFeConfig();
  }

  function toggleDisplayAlert() {
    const el = document.getElementById("nfe-settings-alert-success");
    el.classList.remove("d-none");
    setInterval(() => el.classList.add("d-none"), 6000);
  }

  React.useEffect(() => {
    setTimeout(() => {
      loadNFeConfig();
    }, 1000);
  }, []);

  return (
    <Container>
      <div className="mb-3 py-1">
        <Text>Configurações para emissão</Text>
        <checkNFePermissions />
        <div className="d-flex flex-row">
          <div className="d-flex flex-column">
            <Text>
              NF-e:{" "}
              {config.nfe_number ? (
                config.nfe_number
              ) : (
                <i className="fa fa-spinner fa-spin mr-2" />
              )}
            </Text>
            <small>Número da NF-e</small>
          </div>
          <div>
            <p className="mx-2">-</p>
          </div>
          <div className="d-flex flex-column">
            <Text>
              NF-e:{" "}
              {config.nfe_serie ? (
                config.nfe_serie
              ) : (
                <i className="fa fa-spinner fa-spin mr-2" />
              )}
            </Text>
            <small>Série da NF-e</small>
          </div>
          <div className="ml-4 d-flex flex-column justify-content-center">
            <IconButton
              onClick={openModal}
              icon="edit"
            />
            <small>Editar configurações</small>
          </div>
        </div>
        <div
          className="alert alert-primary d-none"
          id="nfe-settings-alert-success"
        >
          <small>As ocnfigurações foram atualizadas!</small>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => ShowModal(false)}
        size="lg"
        title="Configurações para emissão de NF-e"
      >
        <LoadingInput
          focus={true}
          loading={loading}
          label="Número da NF-e"
          name="nfe_number"
          type="number"
          onKeyDown={enterPressed}
          onChange={onChange}
          value={config.nfe_number}
        />
        <LoadingInput
          loading={loading}
          name="nfe_serie"
          type="number"
          onKeyDown={enterPressed}
          onChange={onChange}
          label="Série da NF-e"
          value={config.nfe_serie}
        />
        <LoadingInput
          as="textarea"
          rows={4}
          name="nfe_fisco_information"
          loading={loading}
          onChange={onChange}
          label="Informações de FISCO"
          value={config.nfe_fisco_information}
        />

        <Button onClick={update} disabled={loading} variant="primary">
          <i className={loading ? "d-none" : "fas fa-save mr-3"} />
          &nbsp; Atualizar configurações &nbsp;{" "}
          <i className={loading ? "fas fa-spinner fa-spin ml-2" : "d-none"} />
        </Button>
      </Modal>
    </Container>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Config/index.jsx